const tryRequire = require('try-require')

module.exports = function (state, opts, config) {
  const SpritesmithPlugin = tryRequire('webpack-spritesmith')

  if (!SpritesmithPlugin) {
    return {} // waiting for an installation
  }

  const path = require('path')

  return new SpritesmithPlugin({
    src: {
        cwd: path.resolve(state.PROJECT_PATH, 'src/client/'),
        glob: '**/sprites/**/*.png'
    },
    target: {
        image: 'dist/client/sprites/sprite.png',
        css: 'dist/client/sprites/sprite.css'
    },
    apiOptions: {
      cssImageRef: "sprite.png",
      generateSpriteName (fullPath) {
        // shouldAddSprites = true
        fullPath = path.basename(fullPath)
        return fullPath.replace(/\.[^\.]+$/, '')
      }
        // cssImageRef: "~sprite.png"
    }
  })
}


// WEBPACK FOOTER //
// ./src/technologies/sprites.js